exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rQQG7{width:30%;height:100%;border-right:1px solid #d9d9d9}body.reader-night-mode .rQQG7{border-color:#2e2e2e;background-color:#3d3d3d}", ""]);

// exports
exports.locals = {
	"notes-wrapper": "rQQG7"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[hash:base64:5]","importLoaders":2}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./src/containers/NotesContainer/NotesContainer.scss
// module id = XFsL
// module chunks = 3